import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { RetailerService } from '../../../api/retailer.service';
import { IPrinter, IUpdatePrinter } from '../../models/models';
import { PrintersService } from '../../services/printers.service';

class AddEditPrinterComponent {
    public static $inject = [
        'notificationService',
        '$state',
        '$translate',
        'printersService',
        'retailerService',
        '$uibModal'
    ];

    public waiting = false;
    public isNew: boolean;
    public printer: IPrinter;
    public form: ng.IFormController;
    public copyValues = Array.from(Array(6).keys()).filter((item) => item > 0);
    public buzzValues = Array.from(Array(4).keys());

    private defaultPrinter: IPrinter = {
        PlaceDetails: null,
        PrinterID: null,
        PrinterPath: null,
        PrinterAccessID: null,
        CopyCount: 1,
        StartBuzzer: 1,
        EndBuzzer: 0
    };
    private originPlaceID: number;

    constructor(
        private notificationService: NotificationService,
        private $state: StateService,
        private $translate: angular.translate.ITranslateService,
        private printersService: PrintersService,
        private retailerService: RetailerService,
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {
    }

    public async $onInit() {
        const printerID = parseInt(this.$state.params.printerID, 10);
        const placeID = parseInt(this.$state.params.placeID, 10);
        this.isNew = isNaN(printerID) || isNaN(placeID);
        if (!this.isNew) {
            await this.loadData(printerID, placeID);
            this.originPlaceID = placeID;
        } else {
            this.printer = {...this.defaultPrinter};
        }
    }

    public getLogoUrl(iconId: number): string {
        return this.retailerService.getStoreLogoUrl(iconId, 48, 48);
    }

    public async selectLocation() {
        const operationResult: any = await this.$uibModal.open({
            component: 'selectSingleLocation',
            resolve: { options: () => {
                    return {
                        selectedLocationID: this.printer.PlaceDetails ? this.printer.PlaceDetails.PlaceID : null,
                        onlyWithoutPrinter: true
                    };
                } },
            size: 'md',
            backdrop: 'static',
            windowClass: 'modal-design-v2'
        }).result;

        if (operationResult.status === 'ok') {
            this.printer.PlaceDetails = {
                PlaceID: operationResult.selectedLocation.ID,
                Name: operationResult.selectedLocation.Name,
                IconId: operationResult.selectedLocation.LogoID,
                Town: operationResult.selectedLocation.Town,
                AddressLine1: operationResult.selectedLocation.Address,
                AddressLine2: null,
                PostCode: null
            };
            this.form.$setDirty();
        }
    }

    public removeLocation() {
        this.printer.PlaceDetails = null;
        this.form.$setDirty();
    }

    public async save() {
        if (!this.form.$valid || !this.printer.PlaceDetails) {
            this.notificationService.showErrorMessage(this.$translate.instant('form_has_errors'));
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const savingData = this.getSavingData();
            if (this.isNew) {
                await this.printersService.createPrinter(savingData);
            } else {
                await this.printersService.updatePrinter(savingData);
            }
            this.notificationService.showSuccessMessage();
            this.waiting = false;
            this.$state.go('app.printers.list');
        } catch (error) {
            this.waiting = false;
            this.notificationService.showErrorMessage(error);
        }
    }

    private async loadData(printerID: number, placeID: number) {
        if (this.waiting) {
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            this.printer = await this.printersService.getPrinter(printerID, placeID);
            this.notificationService.clearAll();
            this.waiting = false;
        } catch (error) {
            this.notificationService.showErrorMessage(error);
            this.waiting = false;
        }
    }

    private getSavingData(): IUpdatePrinter {
        const data: IUpdatePrinter = {
            PrinterPath: this.printer.PrinterPath,
            PrinterAccessID: this.printer.PrinterAccessID,
            CopyCount: this.printer.CopyCount,
            StartBuzzer: this.printer.StartBuzzer,
            EndBuzzer: this.printer.EndBuzzer,
            PlaceID: this.printer.PlaceDetails.PlaceID
        };
        if (!this.isNew) {
            data.PrinterID = this.printer.PrinterID;
        }
        return data;
    }
}

angular.module('naut').component('addEditPrinterComponent', {
    template: require('./add-edit-printer.component.html'),
    controller: AddEditPrinterComponent,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/printers/components/add-edit-printer/add-edit-printer.component.ts